import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=25538066&scoped=true"
import script from "./NoPermission.vue?vue&type=script&lang=ts"
export * from "./NoPermission.vue?vue&type=script&lang=ts"
import style0 from "./NoPermission.vue?vue&type=style&index=0&id=25538066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25538066",
  null
  
)

export default component.exports